import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const AutomatedMarketingPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.fullAccess,
  routes: [
    {
      path: routesUrl.marketingList,
      component: React.lazy(() => import('./page/AutomatedMarketingPage')),
    },
    {
      path: routesUrl.marketingNewCustomer,
      component: React.lazy(() => import('./page/AutomatedMarketingNewCustomerPage')),
    },
    {
      path: routesUrl.marketingBirthday,
      component: React.lazy(() => import('./page/AutomatedMarketingBirthdayPage')),
    },
    {
      path: routesUrl.marketingLostCustomer,
      component: React.lazy(() => import('./page/AutomatedMarketingLostCustomerPage')),
    },
  ],
};

export default AutomatedMarketingPageConfig;
